import styled from "styled-components";
import Backdrop from "components/global/Backdrop";

export const ManageChannelsWrapper = styled.div`
  padding: 2.4rem;

  .connectChannels {
    height: 4.8rem;
    border-radius: 0.8rem;
    background-color: var(--primary);
    padding: 0 3.6rem;
    transition: all 0.2s ease-out;

    &:hover {
      background-color: var(--primary_light);
    }
  }

  .doneBtn {
    width: 56rem;
  }

  .connectTiktokInfo {
    .list-items {
      font-size: 14px;
      font-weight: 450;
      line-height: 18px;
      color: var(--body_text);
      margin-left: 2.4rem;
      li {
        margin-bottom: 5px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    padding: 4.8rem 2.4rem;

    .title {
      font-size: 24px;
      line-height: 32px;
    }

    .brandName {
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
    }

    .manageChannelPageTitle {
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
    }

    .doneBtn {
      width: 100%;
    }

    .connectChannelsHeader {
      flex-flow: column;
      align-items: flex-start;
      gap: 1.2rem;
    }
  }
`;

export const ConnectItem = styled.div`
  display: grid;
  grid-template-columns: 34px auto 108px;
  grid-gap: 1.2rem;
  align-items: center;
  width: 56rem;
  padding: 1.8rem 2.4rem;
  border-radius: 0.8rem;
  margin-bottom: 2.4rem;
  background-color: var(--white);
  color: var(--grey_1);
  border: 1px solid var(--grey_9);

  &:last-child {
    margin-bottom: 0;
  }

  &[data-disabled="true"] {
    opacity: 0.3;
    pointer-events: none;
  }

  .text {
    max-width: 90%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;

    .username,
    .platform {
      max-width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .connect {
    background-color: var(--white);
    border: 1px solid var(--grey_10);
    border-radius: 8px;
    padding-block: 0.6rem;
    transition: all 0.2s ease-out;
    width: 100%;
    color: var(--secondary);
    font-size: 14px;
    font-weight: 450;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    &:not([disabled]):hover {
      background-color: var(--primary_light);
      border: 1px solid var(--primary_light);
      color: var(--white);

      img {
        filter: brightness(0) invert(1);
      }
    }
  }

  .lock-btn {
    border: 1px solid var(--grey_10);
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 14px;
    gap: 4px;

    &:hover {
      background-color: var(--background);
    }
  }

  .refreshIndicator {
    border-radius: 8px;
    padding: 0.6rem;
    gap: 0.6rem;
    width: 100%;
    background-color: #ff4c4d0a;
    opacity: 0;
    pointer-events: none;
    transition: all 0.2s ease-out;

    &.active {
      opacity: 1;
      pointer-events: all;
    }

    .icon {
      width: 16px;
    }
  }

  &.connected {
    grid-template-columns: 34px auto 93px 19px;
    background-color: var(--white);
    color: var(--grey_1);
    border: 1px solid var(--grey_9);
    position: relative;

    .options {
      width: 200px;
      border-radius: 8px;
      box-shadow: var(--shadow);
      background-color: #ffffff;
      position: absolute;
      right: 2.4rem;
      top: 6rem;
      z-index: 10;
      transition: all 0.2s ease-out;
      opacity: 0;
      pointer-events: none;
    }

    .options.open {
      opacity: 1;
      pointer-events: all;
    }

    .options .actionBtn {
      height: 56px;
      transition: all 0.2s ease-out;
      width: 100%;
      padding-left: 2.4rem;
    }

    .options .actionBtn:hover {
      background-color: var(--background);
    }

    .text {
      font-weight: 400;
    }
  }

  .toggleOptions {
    height: 20px;
    width: max-content;
    border-radius: 2px;
    transition: all 0.2s ease-out;

    &:hover {
      background-color: var(--background);
    }

    .icon {
      height: 20px;
    }
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 1rem 2.4rem;
    grid-template-columns: 34px auto 90px;

    .connect,
    .remove {
      padding-inline: 1.2rem;
      font-size: 14px;
    }

    .text {
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
    }
  }
`;

export const Photo = styled.div`
  position: relative;

  #photoInput {
    display: none;
  }

  .platformImg {
    position: absolute;
    overflow: hidden;
    bottom: 0;
    height: 20px;
    width: 20px;
    left: 2.4rem;
    border: 1px solid #ffffff;
    border-radius: 50%;
  }

  @media screen and (max-width: 768px) {
    .platformImg {
      height: 1.8rem;
      width: 1.8rem;
      left: 1.8rem;

      .icon {
        height: 1.6rem;
      }
    }

    .imgWrapper {
      height: 3.2rem;
    }
  }
`;

export const ConnectInfo = styled(Backdrop)`
  display: none;

  &.show {
    display: block;
  }

  .card {
    width: ${({ isFacebook, isInstagram, igPrompt }) =>
      isFacebook
        ? "552px"
        : isInstagram
        ? "772px"
        : igPrompt
        ? "450px"
        : "43rem"};
    padding: ${({ isInstagram, igPrompt }) =>
      isInstagram ? "24px" : igPrompt ? "24px" : "4.8rem"};
    background-color: var(--white);
    border-radius: 1.6rem;
    margin: 20px auto;

    .header {
      font-size: 18px;
      font-weight: 700;
      line-height: 20px;
    }

    p {
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
      line-height: 20px;
      color: var(--body_text);
    }

    a {
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
      color: var(--secondary);
    }

    .list-items {
      font-size: 14px;
      font-weight: 450;
      line-height: 20px;
      color: var(--body_text);
      margin-left: 2.4rem;
      li {
        margin-bottom: 5px;
      }
    }
  }

  .image {
    display: block;
    width: 14.8rem;
    // margin: auto;
  }

  .guideItem {
    width: 100%;
    border: solid #e2e2ea;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 8px;

    p {
      margin: 0;
    }
  }

  .flexGap {
    gap: 16px;
  }

  ul {
    padding-inline-start: 1.5rem;
    list-style-type: disc;
  }

  .btn {
    height: 4.8rem;
    width: calc(100% - 2.4rem);
    border-radius: 0.8rem;
    padding: 0 1.2rem;
    font-size: 14px;

    &.fullWidth {
      width: 100%;
    }

    &.cancel {
      border: 1px solid var(--grey_10);
      color: var(--grey_1);
      background-color: transparent;

      &:not([disabled]):hover {
        background-color: var(--background);
        color: var(--grey_1);
      }
    }

    &.actionBtn {
      background-color: var(--secondary);
      color: var(--white);

      &:not([disabled]):hover {
        background-color: var(--primary_light);
        color: #ffffff;
      }
    }

    &:disabled {
      background-color: var(--secondary_1);
    }
  }

  .iconContainer {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .iconWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: 2px solid #e2e2ea;
    padding: 8px;
    border-radius: 8px;
    width: 48px;
    height: 48px;
  }

  .igImage {
    border-radius: 8px;
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 2.4rem);
      padding: 2.4rem;

      .header {
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
      }

      h4 {
        font-size: 18px;
        line-height: 24px;
      }

      p {
        font-size: 14px;
        line-height: 20px;
      }
    }
    .igImage {
      display: none;

      video {
        display: none;
      }
    }
  }

  @media screen and (min-width: 1440px) {
    .card {
      margin: 7% auto;
    }
  }
`;

export const SelectModal = styled(Backdrop)`
  .card {
    width: 43rem;
    max-height: 61.4rem;
    padding: 4.8rem 0 0;
    background-color: var(--white);
    border-radius: 1.6rem;
    overflow: hidden;
    transition: var(--transition_default);
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

    &::-webkit-scrollbar {
      display: none;
    }

    .block {
      max-height: 200px;
      overflow-y: auto;
    }

    .description {
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
      line-height: 20px;
    }

    .divider {
      height: 1px;
      width: 100%;
      background-color: var(--grey_9);
      margin: 2.4rem 0;
    }
  }

  .cardBody {
    padding-inline: 4.8rem;
  }

  .btn {
    height: 4.8rem;
    width: calc(100% - 2.4rem);
    border-radius: 0.8rem;
    padding: 0 1.2rem;
    font-size: 14px;

    &.cancel {
      border: 1px solid var(--grey_10);
      color: var(--grey_1);
      background-color: transparent;

      &:not([disabled]):hover {
        background-color: var(--background);
        color: var(--grey_1);
      }
    }

    &.actionBtn {
      background-color: var(--secondary);
      color: var(--white);

      &:not([disabled]):hover {
        background-color: var(--primary_light);
        color: #ffffff;
      }
    }

    &:disabled {
      background-color: var(--secondary_1);
    }
  }

  .actionBtns {
    position: sticky;
    left: 0;
    width: 100%;
    bottom: 0;
    padding: 2.4rem 4.8rem 4.8rem;
    background-color: #ffffff;
    border-top: 1px solid var(--grey_9);
  }

  .chooseTargetItem {
    cursor: pointer;
    margin-bottom: 1.2rem;

    &:last-child {
      margin-bottom: 0;
    }

    label {
      font-size: 18px;
      line-height: 24px;
      cursor: pointer;
    }
  }

  .disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  .user-image-container {
    position: relative;
    width: 40px;
    height: 40px;

    .social-icon {
      position: absolute;
      bottom: 0;
      right: -8px;
      background-color: #fff;
      padding: 4px;
      border-radius: 50%;
      width: 24px;
      height: 24px;
    }
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 2.4rem);
      padding: 2.4rem;

      h5 {
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
      }

      .description {
        font-size: 14px;
        font-style: normal;
        font-weight: 450;
      }

      h4 {
        font-size: 18px;
        line-height: 24px;
      }

      p {
        font-size: 14px;
        line-height: 20px;
      }
    }

    .cardBody {
      padding-inline: 0;
    }

    .actionBtns {
      padding: 2.4rem 0 0;
    }
  }
`;

export const BannerWrapper = styled.div`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background-color: ${(props) =>
    // @ts-ignore
    props.bg ? props.bg : "#ffebeb"};
  gap: 8px;
  display: flex;

  .content {
    color: ${(props) =>
      // @ts-ignore
      props.contentColor
        ? // @ts-ignore
          props.contentColor
        : "#9e0a05"};
  }
`;
